<div class="dashboard-buttons" [class.newsite]="newSite()">
  @if (displayRegisterNewReferralEvent()) {
    <button routerLink="/register-new-event" class="dashboard-button">
      <div class="button-header-purple">Register New Referral Event</div>
      <div class="button-icon">
        <img
          src="assets/images/icons/home-page/register_new_event_icon.png"
        />
      </div>
    </button>
  }
  @if (displayReferralEventSearch()) {
    <button
      class="dashboard-button"
      (click)="searchEvents(searchType.Future)"
    >
      <div class="button-header-blue">Future<br />Events</div>
      <div class="button-icon">
        <img
          style="margin-right: 8px"
          src="assets/images/icons/home-page/future_events_icon.png"
        />
      </div>
    </button>
    <button class="dashboard-button" (click)="searchEvents(searchType.Past)">
      <div class="button-header-blue">Past<br />Events</div>
      <div class="button-icon">
        <img
          style="margin-left: 4px; margin-bottom: 3px"
          src="assets/images/icons/home-page/past_events_icon.png"
        />
      </div>
    </button>
    <button
      class="dashboard-button"
      (click)="searchEvents(searchType.NonTransferred)"
    >
      <div class="button-header-blue">Events Not Transferred</div>
      <div class="button-icon">
        <img
          style="margin-right: 2px; margin-bottom: 2px"
          src="assets/images/icons/home-page/events_not_transferred_icon.png"
        />
      </div>
    </button>
    <button
      class="dashboard-button"
      (click)="searchEvents(searchType.NotAccepted)"
    >
      <div class="button-header-blue">Events Not Accepted</div>
      <div class="button-icon">
        <img
          style="margin-right: 2px; margin-bottom: 2px"
          src="assets/images/icons/home-page/events_not_accepted_icon.png"
        />
      </div>
    </button>
  }
</div>
